<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Info</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse('show')"
                        >
                            <i
                                :class="changeIcon(getCollapseStatus('show'))"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <vue-slide-up-down
                    :active="getCollapseStatus('show')"
                    :duration="durationCollapse"
                >
                    <div>
                        <div
                            v-if="shortDomainAccount.id"
                            class="box-body"
                        >
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Name:</strong>
                                    <p>
                                        <span>{{ shortDomainAccount.name }}</span>
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Category:</strong>
                                    <p>
                                        <a
                                            :href="getRoute(shortDomainAccount.category.id, 'categories')"
                                            :title="shortDomainAccount.category.name"
                                        >
                                            {{ shortDomainAccount.category.name }}
                                        </a>
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Created At:</strong>
                                    <p>{{ shortDomainAccount.created_at }}</p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Updated At:</strong>
                                    <p>{{ shortDomainAccount.updated_at }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Provider:</strong>
                                    <p>
                                        <span>{{ shortDomainAccount.provider.name }}</span>
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Active:</strong>
                                    <p>
                                        <ValueYesNo :value="shortDomainAccount.active" />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Short Domains:</strong>
                                    <p>
                                        <BadgeTotal
                                            :value="shortDomainAccount.domains_count"
                                            color="gray"
                                        />
                                        <BadgeTotal
                                            :value="shortDomainAccount.domains_count_active"
                                            color="green"
                                        />
                                        <BadgeTotal
                                            :value="shortDomainAccount.domains_count_inactive"
                                            color="red"
                                        />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Parse Page:</strong>
                                    <p>
                                        <BadgeTotal
                                            :value="shortDomainAccount.parse_page"
                                            color="gray"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </vue-slide-up-down>
            </div>
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Short Domains</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse('list')"
                        >
                            <i
                                :class="changeIcon(getCollapseStatus('list'))"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <vue-slide-up-down
                    :active="getCollapseStatus('list')"
                    :duration="durationCollapse"
                >
                    <ShortDomainsTable
                        :route="route"
                        :type="type"
                    />
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../subcomponents/ValueYesNo';
import BadgeTotal from '../subcomponents/BadgeTotal';
import ShortDomainsTable from '@/components/short-domains/ShortDomainsTable';

export default {
    components: {
        ValueYesNo,
        BadgeTotal,
        ShortDomainsTable,
    },
    props: {
        pageId: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            shortDomainAccount: {},
            shortDomains: {},
            stats: {},
            route: {
                categories: '/sd-accounts/categories/:id:',
                show: '/short-domains/:id:',
                edit: '/short-domains/:id:/edit',
                feedbackShow: '/feedback/:id:',
                campaignsShow: '/campaigns/:id:',
                sdAccountsShow: '/sd-accounts/:id:',
            },
            type: {
                campaign: 'SMSPlatform\\Models\\Campaign\\Campaign',
                feedback: 'SMSPlatform\\Models\\Feedback\\Feedback',
            },
            collapse: {
                show: true,
                list: true,
            },
            durationCollapse: 700,
        };
    },
    mounted() {
        this.getData(this.pageId);
    },
    methods: {
        getData(id) {
            axios
                .get('/sd-accounts/' + id + '/data-top')
                .then((response) => {
                    this.isFetching = false;
                    this.shortDomainAccount = response.data;
                    this.shortDomains = response.data.shortDomains;
                })
                .catch(() => {});
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        toggleCollapse(type) {
            this.collapse[type] = !this.collapse[type];
        },
        getCollapseStatus(type) {
            return this.collapse[type];
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
    },
};
</script>
